export default __webpack_public_path__ + "static/media/Karthik.495c5c0c.jpeg";